export default {
  SYSTEM_ADMIN: "SystemAdmin"
}